import { ILocation } from "src/domain/entities"
import { locationListApi } from "../../api/location/locationListApi"

type PayloadShape = Parameters<typeof locationListApi>[0]

export async function locationListService(payload: PayloadShape, token?: null | string) {
	const location = await locationListApi(payload, token)
	return location as NonNullable<ILocation[]>
}
